import React, { ReactNode } from 'react'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { reverseUrl } from '../../../../navigation/reverseUrl'
import { PostNavigationItem } from '../PostNavigationItem'
import { PostCallout } from '../PostCallout'
import { PostOfferCard } from '../../../../generated/api/post-row'

interface PostLocalOffersProps {
  offers: PostOfferCard[]
  societyId: string
}

export const PostLocalOffers = ({
  offers,
  societyId,
}: PostLocalOffersProps): ReactNode => {
  const { translate } = useAppTranslation()

  if (offers.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <PostCallout text={translate('post.newLocalOfferText')} />
      {offers.map((offer) => (
        <PostNavigationItem
          key={offer.id}
          text={`${translate('localOfferView.title')}: ${offer.companyName} - ${
            offer.discountHeader
          }`}
          url={reverseUrl('society:local-offers-detail', {
            id: offer.societyId ?? societyId,
            offerId: offer.id,
          })}
        />
      ))}
    </div>
  )
}
